import { ADMIN_PROFILES } from "@/constants/constants";
import { create } from "zustand";

export type Me = {
  airports: string[];
  name: string;
  email: string;
  payrollNumber: string;
  profile: string;
  userId: string;
  status: string;
};

type User = {
  me: Me | null;
  role: string | null;
  isAuthenticated: boolean;
  isSupervisor: boolean;

  setUser: (user: Me | null) => void;
  clearUser: () => void;
};

export const useUserStore = create<User>((set) => ({
  me: null,
  role: null,
  isAuthenticated: false,
  isSupervisor: false,

  setUser: (user) =>
    set({
      me: user,
      role: user?.profile ?? null,
      isAuthenticated: !!user,
      isSupervisor: user ? ADMIN_PROFILES.includes(user.profile) : false,
    }),

  clearUser: () =>
    set({
      me: null,
      role: null,
      isAuthenticated: false,
      isSupervisor: false,
    }),
}));
